import request from './request';

const inviteService = {
  getAll: (params) =>
    request.get('dashboard/admin/invites/paginate', { params }),
  statusUpdate: (id, params) =>
    request.post(
      `dashboard/admin/invites/${id}/status/change`,
      {},
      { params }
    ),
};

export default inviteService;
